export enum AppDomain {
  BPER = "B:Digital Corporate",
}

export enum Theme {
  BPER = "bper",
  NOVA = "nova",
}

export const SECURITY_URL =
  "https://group.bper.it/sicurezza-online";
export const ACCESSIBILITY_URL =
  "https://www.bper.it/documents/d/bper/bper_accessibility_statement_it_2025_unien";
